import { type Fetcher } from '@post-office/placement-data';
import { type Previewer } from '@post-office/placement-preview';
import { createContext } from 'react';

export const PlacementFetchingContext = createContext<Fetcher & Partial<Previewer>>({
	fetch: (...args) => globalThis.fetch(...args),
});
